import type { PathParam } from 'react-router-dom';

export type PathParams<Path extends string> = {
  [K in PathParam<Path>]: string | number;
};

export type RouterPathParams<Path extends string> = {
  [K in PathParam<Path>]: string | null;
};

export const stringifyPathParams = <Path extends string>(params: PathParams<Path>): RouterPathParams<Path> => {
  return Object.fromEntries(
    Object.entries(params).map(([key, value]) => [key, String(value)]),
  ) as RouterPathParams<Path>;
};
